import jsPDF from "jspdf";
import api, { API } from "@/lib/api";

const money = (v) => `€ ${Number(v || 0).toLocaleString("it-IT", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
const METHOD = { contanti: "Contanti / Cash", carta: "Carta / Card", bonifico: "Bonifico / Bank transfer", altro: "Altro / Other" };

function loadLogo(src) {
  return new Promise((resolve) => {
    const img = new Image();
    img.onload = () => {
      try {
        const c = document.createElement("canvas");
        c.width = img.naturalWidth; c.height = img.naturalHeight;
        c.getContext("2d").drawImage(img, 0, 0);
        resolve(c.toDataURL("image/png"));
      } catch { resolve(null); }
    };
    img.onerror = () => resolve(null);
    img.src = src;
  });
}

export async function marketingReceiptBase64(s) {
  const doc = new jsPDF({ unit: "mm", format: "a5" });
  const M = 14, W = 148;
  let y = 16;
  const logo = await loadLogo("/blu-lodge-logo.png");
  if (logo) doc.addImage(logo, "PNG", M, y - 6, 16, 16);
  doc.setFont("helvetica", "bold"); doc.setFontSize(14); doc.text("Blu Lodge Maldives", M + 20, y);
  doc.setFont("helvetica", "normal"); doc.setFontSize(8); doc.text("Keyodhoo - Vaavu Atoll - Maldives", M + 20, y + 5);
  y += 20;
  doc.setFont("helvetica", "bold"); doc.setFontSize(12); doc.text("RICEVUTA DI PAGAMENTO / PAYMENT RECEIPT", M, y);
  y += 7; doc.setFont("helvetica", "normal"); doc.setFontSize(9);
  doc.text(`N. ${s.receipt_no || "-"}`, M, y); doc.text(`Data / Date: ${s.date.split("-").reverse().join("/")}`, W - M, y, { align: "right" });
  if (s.client) { y += 5; doc.text(`Cliente / Guest: ${s.client}`, M, y); }
  y += 9; doc.setFillColor(240, 245, 250); doc.rect(M, y - 4.5, W - 2 * M, 7, "F"); doc.setFont("helvetica", "bold");
  doc.text("Articolo / Item", M + 2, y); doc.text("Q.tà", 88, y, { align: "right" }); doc.text("Prezzo", 108, y, { align: "right" }); doc.text("Totale", W - M - 2, y, { align: "right" });
  y += 8; doc.setFont("helvetica", "normal");
  const lines = s.lines?.length ? s.lines : [{ name: s.item_name || s.type, qty: s.qty, unit_price: s.unit_price, total: s.total }];
  lines.forEach((l) => {
    if (y > 185) { doc.addPage(); y = 16; }
    doc.text(String(l.name).slice(0, 40), M + 2, y); doc.text(String(l.qty), 88, y, { align: "right" });
    doc.text(money(l.unit_price), 108, y, { align: "right" }); doc.text(money(l.total), W - M - 2, y, { align: "right" });
    y += 6;
  });
  y -= 2; doc.setDrawColor(200); doc.line(M, y, W - M, y);
  y += 8; doc.setFont("helvetica", "bold"); doc.setFontSize(11); doc.text("TOTALE PAGATO / TOTAL PAID", M + 2, y); doc.text(money(s.total), W - M - 2, y, { align: "right" });
  y += 7; doc.setFont("helvetica", "normal"); doc.setFontSize(9); doc.text(`Pagamento / Payment: ${METHOD[s.payment_method] || s.payment_method}`, M + 2, y);
  y += 14; doc.setFontSize(9); doc.text("Grazie! / Thank you!", M, y);
  doc.setFontSize(7); doc.setTextColor(120); doc.text("www.blulodgemaldives.com", M, 200);
  return doc.output("datauristring").split(",")[1];
}

export async function sendMarketingReceipt(s, win = window.open("about:blank", "_blank"), viaBar = false) {
  try {
    return await sendReceipt(s, win, viaBar);
  } catch (e) {
    if (win) win.close();
    throw e;
  }
}

async function sendReceipt(s, win, viaBar) {
  const pdf_base64 = await marketingReceiptBase64(s);
  const path = viaBar ? `/bar/sales/${s.id}/document` : `/marketing/sales/${s.id}/document`;
  const { data } = await api.post(path, { pdf_base64, public_base: API.replace(/\/api\/?$/, "") });
  const what = s.source === "bar" ? `consumi bar ${money(s.total)}` : `${s.item_name} ×${s.qty}, ${money(s.total)}`;
  const msg = `Ciao ${s.client || ""}! Ecco la ricevuta del tuo acquisto (${what}) presso Blu Lodge Maldives:\n${data.public_url}`;
  const digits = (s.client_phone || "").replace(/[^0-9]/g, "").replace(/^00/, "");
  const url = `https://api.whatsapp.com/send?phone=${digits}&text=${encodeURIComponent(msg)}`;
  if (win) win.location.href = url; else window.location.href = url;
  return data;
}
